// src/store/slices/pomodoroSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PomodoroState {
  secs: number;
  running: boolean;
  type: 'work' | 'break';
  count: number;
  visible: boolean;
}

const initialState: PomodoroState = {
  secs: 25 * 60,
  running: false,
  type: 'work',
  count: 0,
  visible: false,
};

const pomodoroSlice = createSlice({
  name: 'pomodoro',
  initialState,
  reducers: {
    tick: (state) => { if (state.secs > 0) state.secs--; },
    setRunning: (state, action: PayloadAction<boolean>) => { state.running = action.payload; },
    switchType: (state, action: PayloadAction<'work' | 'break'>) => {
      state.type = action.payload;
      state.secs = action.payload === 'work' ? 25 * 60 : 5 * 60;
      state.running = false;
      if (action.payload === 'break') state.count++;
    },
    reset: (state) => {
      state.secs = 25 * 60;
      state.running = false;
      state.type = 'work';
    },
    toggleVisible: (state) => { state.visible = !state.visible; },
  },
});

export const { tick, setRunning, switchType, reset, toggleVisible } = pomodoroSlice.actions;
export default pomodoroSlice.reducer;
